<template>
  <DeadlineBadge
    :key="locale"
    :style="{
      'margin-left': color === 'FFFFFF00' ? 0 : '7px',
    }"
    :deadline="deadline"
    :color="color"
    date-only
  />
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import { computed, type PropType } from "vue";
import { getBadgeColorNew } from "@/functions/badgeColor";
import type { EABEventActionType } from "./EventActionHelper";
import DeadlineBadge from "@/components/badges/DeadlineBadge.vue";
const props = defineProps({
  action: {
    type: Object as PropType<EABEventActionType>,
    required: true,
  },
});
const deadline = computed(() => props.action.deadline);
const color = computed(() => {
  return getBadgeColorNew(props.action.status, props.action.deadline);
});

const { locale } = useTranslation();
</script>

<style lang="scss" scoped></style>
